import { useLocation, useParams } from 'react-router';
import { parse } from 'query-string';
import { useSelector } from 'react-redux';
import { getSubproject } from '../../project/subproject-selectors';

export const useSubproject = (id) => {
    const location = useLocation();
    const params = useParams();
    const subprojectId = id || findSubprojectId(location, params);
    const subproject = useSelector((state) => getSubproject(state, subprojectId));
    const isFetchingSubproject = !!subproject?.isFetching;

    return {
        subprojectId,
        subproject,
        isFetchingSubproject,
    };
};

const findSubprojectId = (location, params) => {
    const subprojectIdFromUrl = params.subprojectId || parse(location.search).subproject;
    if (subprojectIdFromUrl) {
        return parseInt(subprojectIdFromUrl, 10);
    }
    return undefined;
};
